import { setModalState } from '@/redux/actions/uiActions/modalActions.js';
import memoizeSelector from '@/redux/lib/memoizeSelector';
import selectors from '@/redux/selectors/selectors.js';
import { modal } from '@/redux/selectors/uiSelectors';
import { toTitleCase } from '@shared/utils/toTitleCase.js';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import ModalV2 from '@/components/ModalV2.jsx';

const PermissionsModal = () => {
  const permissions = useSelector(selectors.permissions);
  const modalState = useSelector(memoizeSelector('modal:permissions', (state) => modal(state, 'permissions')));
  const show = modalState?.open;

  const groupedPermissions = useMemo(() => {
    const uniquePermissions = new Set(permissions);
    const sorted = Array.from(uniquePermissions)
      .map((permission) => permission.trim())
      .sort();

    return sorted.reduce((acc, permission) => {
      const [group] = permission.split(':');
      if (!acc[group]) {
        acc[group] = [];
      }
      acc[group].push(permission);
      return acc;
    }, {});
  }, [permissions]);

  const handleClose = () => {
    setModalState('permissions', { open: false });
  };

  const formatGroupTitle = (group) => {
    return toTitleCase(group.replace(/_/g, ' '));
  };

  return (
    <ModalV2 //
      title={'My Permissions'}
      maxWidth={'600px'}
      className={'permissions-modal'}
      show={show}
      onHide={handleClose}
      centered>
      {Object.entries(groupedPermissions).map(([group, permissions]) => (
        <div className={'permission-group'} key={group}>
          <h3>{formatGroupTitle(group)}</h3>
          <div className="permissions-list">
            {permissions.map((permission) => (
              <div key={permission} className="permission-item">
                <span data-title={permissions[permission]?.description}>{permission}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </ModalV2>
  );
};

export default PermissionsModal;
